import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { WAREHOUSE_TASK_GET_ONE } from 'api/query-keys.ts';
import type { TWarehouseTaskRes } from 'api/swagger';

export const useGetWarehouseTask = (id?: number) => {
  return useQuery({
    queryKey: [WAREHOUSE_TASK_GET_ONE, id],
    queryFn: async ({ signal }) => {
      const { data } = await http.get<TWarehouseTaskRes>(`/v1/warehouse-tasks/${id}`, { signal });
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 10 * 1000,
    cacheTime: 60 * 1000,
    enabled: !!id,
  });
};
